<template>
	<div class="flex flex-col min-h-screen bg-white">
		<!-- Navigation -->
		<AppNavigation />

		<!-- Main Content -->
		<main class="flex-1">
			<slot />
		</main>

		<!-- Footer -->
		<AppFooter />
	</div>
</template>

<script setup lang="ts">
import AppNavigation from './AppNavigation.vue';
import AppFooter from './AppFooter.vue';
</script>

<style scoped>
/* Ensure full height layout */
:deep(body) {
	min-height: 100vh;
}
</style>
